import AuthLayout from "./auth-layout.container";

export default AuthLayout